import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/select-all.svg
 */
const IconSelectAll: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path d="M5 5h4v4H5V5zM5 15h4v4H5v-4z" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 4H4v6h6V4zM3 3v8h8V3H3zM10 14H4v6h6v-6zm-7-1v8h8v-8H3z"
      fill="currentColor"
    />
    <path d="M13 5h8v4h-8V5zM13 15h8v4h-8v-4z" fill="currentColor" />
  </svg>
);

export default IconSelectAll;
